import * as React from "react";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { TestResults } from "./PFTAPITypes";
import { TestQualityGradeIndicator } from "./TestQualityGradeIndicator";
import { TestQualityGrade } from "./TestQualityGrading";

export interface Grades {
    fev1: TestQualityGrade;
    fvc: TestQualityGrade;
}

export interface TestAcceptabilityTableProps {
    displayTechnicianAcceptability: boolean;
    isViewOnly: boolean;
    isLoading: boolean;
    testResults: Array<TestResults>;
    grades: Grades;
    onAcceptabilityChange: (testId: string, checked: boolean) => void;
}

export const TestAcceptabilityTable = ({ displayTechnicianAcceptability, isViewOnly, isLoading, testResults, grades, onAcceptabilityChange }: TestAcceptabilityTableProps) => {
    const { fvcSettings } = useCurrentStudyConfigurationContext();

    return (
        <>
            <tr>
                <td>Acceptable</td>
                {
                    testResults.map((tr) => {
                        return (
                            <td key={`OverreaderAcceptability${tr.TestId}`}>
                                <input disabled={isViewOnly}
                                    checked={tr.OverreaderAcceptability}
                                    data-automationid={`test-acceptability-overread-${tr.TestNumber}`}
                                    type="checkbox"
                                    onChange={(e) => onAcceptabilityChange(tr.TestId, e.target.checked)}
                                />
                            </td>
                        );
                    })
                }
                <td>
                    {fvcSettings.GradingEnabled ?
                        <>
                            <TestQualityGradeIndicator title="FEV1" loading={isLoading} grade={grades.fev1} />
                            <TestQualityGradeIndicator title="FVC" loading={isLoading} grade={grades.fvc} />
                        </>: null}
                </td>
            </tr>
            {displayTechnicianAcceptability ? <tr>
                <td>Technician Acceptability</td>
                {
                    testResults.map((tr) => {
                        return (
                            <td key={`TechnicianAcceptability${tr.TestId}`}>
                                <input disabled={true} readOnly={true}
                                    checked={tr.TechnicianAcceptability}
                                    data-automationid={`test-acceptability-technician-${tr.TestNumber}`}
                                    type="checkbox"
                                />
                            </td>
                        );
                    })
                }
                <td></td>
            </tr> : null}
            
        </>
    );
}
